import { render } from "./SettingSvg.vue?vue&type=template&id=756554b2&ts=true"
import script from "./SettingSvg.vue?vue&type=script&lang=ts"
export * from "./SettingSvg.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__